// @ts-nocheck
// approved estimate data
export const FETCH_APPROVED_ESTIMATE_DATA_REQUEST =
  "FETCH_APPROVED_ESTIMATE_DATA_REQUEST";
export const FETCH_APPROVED_ESTIMATE_DATA_SUCCESS =
  "FETCH_APPROVED_ESTIMATE_DATA_SUCCESS";
export const FETCH_APPROVED_ESTIMATE_DATA_FAILURE =
  "FETCH_APPROVED_ESTIMATE_DATA_FAILURE";

// submitted estimate data
export const FETCH_SUBMITTED_ESTIMATE_DATA_REQUEST =
  "FETCH_SUBMITTED_ESTIMATE_DATA_REQUEST";
export const FETCH_SUBMITTED_ESTIMATE_DATA_SUCCESS =
  "FETCH_SUBMITTED_ESTIMATE_DATA_SUCCESS";
export const FETCH_SUBMITTED_ESTIMATE_DATA_FAILURE =
  "FETCH_SUBMITTED_ESTIMATE_DATA_FAILURE";

// submit estimate data
export const SUBMIT_ESTIMATE_DATA_REQUEST = "SUBMIT_ESTIMATE_DATA_REQUEST";
export const SUBMIT_ESTIMATE_DATA_SUCCESS = "SUBMIT_ESTIMATE_DATA_SUCCESS";
export const SUBMIT_ESTIMATE_DATA_FAILURE = "SUBMIT_ESTIMATE_DATA_FAILURE";

// approve estimate data
export const APPROVE_ESTIMATE_DATA_REQUEST = "APPROVE_ESTIMATE_DATA_REQUEST";
export const APPROVE_ESTIMATE_DATA_SUCCESS = "APPROVE_ESTIMATE_DATA_SUCCESS";
export const APPROVE_ESTIMATE_DATA_FAILURE = "APPROVE_ESTIMATE_DATA_FAILURE";

// fetch unsubmitted positions
export const FETCH_UNSUBMITTED_POSITIONS_REQUEST =
  "FETCH_UNSUBMITTED_POSITIONS_REQUEST";
export const FETCH_UNSUBMITTED_POSITIONS_SUCCESS =
  "FETCH_UNSUBMITTED_POSITIONS_SUCCESS";
export const FETCH_UNSUBMITTED_POSITIONS_FAILURE =
  "FETCH_UNSUBMITTED_POSITIONS_FAILURE";

// update client approve data
export const UPDATE_CLIENT_APPROVE_DATA = "UPDATE_CLIENT_APPROVE_DATA";

// latest estimates of every config
export const GET_ESTIMATES_OF_CONFIG_REQUEST =
  "GET_ESTIMATES_OF_CONFIG_REQUEST";
export const GET_ESTIMATES_OF_CONFIG_SUCCESS =
  "GET_ESTIMATES_OF_CONFIG_SUCCESS";
export const GET_ESTIMATES_OF_CONFIG_FAILURE =
  "GET_ESTIMATES_OF_CONFIG_FAILURE";

// switch estimate config
export const SWITCH_ESTIMATE_CONFIG = "SWITCH_ESTIMATE_CONFIG";

// submit deposit invoice data
export const SUBMIT_DEPOSIT_INVOICE_DATA_REQUEST =
  "SUBMIT_DEPOSIT_INVOICE_DATA_REQUEST";
export const SUBMIT_DEPOSIT_INVOICE_DATA_SUCCESS =
  "SUBMIT_DEPOSIT_INVOICE_DATA_SUCCESS";
export const SUBMIT_DEPOSIT_INVOICE_DATA_FAILURE =
  "SUBMIT_DEPOSIT_INVOICE_DATA_FAILURE";